import { usePilotPlanConfig } from '@/services/hooks/usePilotPlanConfig';
import { MultiAutocomplete } from '@dev/ee-components';
import React, { useEffect } from 'react';
import { noop } from 'lodash-es';
import { useDispatch } from 'react-redux';
import { CountRecipientsSuccess, ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { AutocompleteCategories } from '../SendToInterface';
import { convertToCampaignRecipient } from '../utils/convertToCampaignRecipient';

const id = 'campaign-creator-send-to-input-pilot';
export const PilotPlanRecipients = () => {
    const dispatch = useDispatch();
    const { listsAvailableForSending } = usePilotPlanConfig();

    const sendingLists = listsAvailableForSending?.map((list) => ({
        label: list,
        category: AutocompleteCategories.List,
        isAllContacts: false,
    }));

    useEffect(() => {
        const values = convertToCampaignRecipient(sendingLists);
        const modifyMap = new Map<string, any>();
        modifyMap.set('Targets', values);
        dispatch(ModifyCampaignMap(modifyMap));
        dispatch(CountRecipientsSuccess(1));
    }, []);

    return (
        <MultiAutocomplete id={id} values={sendingLists} options={sendingLists} onChange={noop} readOnly labelOnly />
    );
};
